<template>
  <a-range-picker v-bind="$attrs"> </a-range-picker>
</template>

<script lang="ts">
export default {
  name: 'RangeDatePicker'
}
</script>

<style scoped></style>
